var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMore = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12.01,
  r: 2.5
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 18.5,
  cy: 12.01,
  r: 2.5
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 5.5,
  cy: 12.01,
  r: 2.5
})));
export default SvgMore;